import { type BoxProps, useStyleConfig, Box } from '@chakra-ui/react'
import { clsx } from 'clsx'
import { useOverrideComponentPropsContext } from '../lib/override-component-props'

export type GrandOverlayProps = BoxProps

const GrandOverlay = (_props: GrandOverlayProps) => {
  const mergedProps = useOverrideComponentPropsContext('GrandOverlay', _props)
  const { className, sx, ...props } = mergedProps
  const styles = useStyleConfig('GrandOverlay')

  return (
    <Box
      className={clsx('grand-overlay', className)}
      h="full"
      position="absolute"
      w="full"
      zIndex={1}
      sx={{ ...sx, ...styles }}
      {...props}
    />
  )
}

export default GrandOverlay
